export default "__VITE_ASSET__BTg6KOlT__"